// What the report screens (Sales > Reports, Purchase > Reports) share: the usual periods, how amounts and months are shown on a chart,
// and a CSV download of the table in view.
export const errorMessage = (error, fallback) => {
  const data = error.response?.data;
  return typeof data === 'string' && data ? data : fallback;
};
export const num = (v) => Number(v || 0);

/** The periods owners usually ask about; the financial year runs April to March. */
export function period(key) {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const fyStart = m >= 3 ? y : y - 1;
  switch (key) {
    case 'thisMonth': return [new Date(y, m, 1), now];
    case 'lastMonth': return [new Date(y, m - 1, 1), new Date(y, m, 0)];
    case 'lastFy': return [new Date(fyStart - 1, 3, 1), new Date(fyStart, 2, 31)];
    case 'last12': return [new Date(y, m - 11, 1), now];
    case 'thisFy':
    default: return [new Date(fyStart, 3, 1), now];
  }
}
/** Axis labels in lakh and thousand, with a decimal while they would otherwise repeat (1.4k, 1.1k rather than 1k, 1k). */
export const shortAmount = (v) => {
  const trim = (x) => String(Number(x.toFixed(x < 10 ? 1 : 0)));
  if (v >= 100000) return `${trim(v / 100000)}L`;
  if (v >= 1000) return `${trim(v / 1000)}k`;
  return String(v);
};
export const PERIODS = [['thisMonth', 'This month'], ['lastMonth', 'Last month'], ['thisFy', 'This financial year'], ['lastFy', 'Last financial year'], ['last12', 'Last 12 months']];
export const monthLabel = (key) => {
  const [y, m] = key.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', { month: 'short', year: '2-digit' });
};

export function downloadCsv(name, header, rows) {
  const esc = (v) => {
    const s = v == null ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const text = [header, ...rows].map((r) => r.map(esc).join(',')).join('\n');
  const url = URL.createObjectURL(new Blob([`﻿${text}`], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
